export default __webpack_public_path__ + "static/media/roadmap_title.7a970612.png";